import { CareDocumentOvercomeChallengeRecommendation } from '@packages/core-shared';

export default function buildReactKey(
  rec: CareDocumentOvercomeChallengeRecommendation,
) {
  return `${rec.recommendation} ${rec.timeframe}`;
}
